import { setApiError, setApiLoading, setApiSuccess} from './expenseActions';
import { EXPENSE_DETAILS_CONST } from '../actionConstants';
import { formatExpnsDetailResponse, formatExpenseHistoryRes } from '../../expense/components/ExpenseDetailsInfo/utils';
import { APPLICATION_CONSTANTS } from '../../AppConstants';
import { saveServerLogs } from '../../UtilityComponents/Util';
import { PATHS } from '../../AppConstants';
import { getccbAxiosConfig } from '../../apisSetup/ccbConfig';
import { defaultErrorModalData, defaultSuccessModalData, technicalIssueData, API_MESSAGE } from '../../expense/config';
import { setToastData, removeToastData } from '../../UtilityComponents/expenseUtils';

const axiosApiCaller = getccbAxiosConfig(true, {
    [APPLICATION_CONSTANTS.DEVICE_TYPE_KEY] : APPLICATION_CONSTANTS.DEVICE_TYPE,
    }, false);


const getCommonParams = ({expId, authCode, expKey="id", authKey="authCode"}) => {
    let params = {}
    if (authCode) {
         params = { [authKey]: authCode }
    } else {
        params = { [expKey]: expId }
    }
    return params;
}

const saveExpenseDetails = (data) => {
    let payload = {}
    if (data) {
        const { expenseData = {}, expenseItems = []} = formatExpnsDetailResponse(data);
        payload = {
            type: EXPENSE_DETAILS_CONST.EXPNS_DETAIL,
            payload: {
                expenseData,
                expenseItems,
                error: false,
            }
        }
    }
    return payload;
} 
export const fetchExpnsDetails = ({expId, authCode}) => async (dispatch) => {
    dispatch(setApiLoading(true));
    let isError = false;
    const params = getCommonParams({expId, authCode});
    try {
        const url = authCode ? PATHS.GET_EXPENSE_DETAILS_AUTH : PATHS.GET_EXPENSE_DETAILS;
        const resp = await axiosApiCaller.get(url, {
            params
        });
        const { data } = resp || {};
        if (data && data.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
            dispatch(saveExpenseDetails(data))
        } else {
            isError = true;
        }
    } catch(err) {
        isError = true;
		saveServerLogs(e.stack, 'error', PATHS.GET_EXPENSE_DETAILS);
    } finally {
        dispatch(setApiLoading(false));
        if (isError) {
            dispatch({
                type: EXPENSE_DETAILS_CONST.EXPNS_DETAIL,
                payload: {
                    error: true,
                }
            });
        }
    }
}

export const fetchExpenseHistory = ({expId, authCode}) => async dispatch => {
    const params = getCommonParams({expId, authCode, expKey: 'expenseId'});
    try {
        const url = authCode ? PATHS.EXPENSE_AUTH_HISTORY : PATHS.EXPENSE_HISTORY;
        const resp = await axiosApiCaller.get(url, {
            params
        });
        const { data } = resp || {} 
        if (data && data.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
            const expenseHistory = formatExpenseHistoryRes(data);
            dispatch({
                type: EXPENSE_DETAILS_CONST.EXPNS_HISTORY,
                payload: {
                    expenseHistory,
                }
            });
        } else {
            const { message = ''} = data || {};
            dispatch(setApiError({
                ...defaultErrorModalData,
                desc: message,
            }));
        }
    } catch(err) {
        dispatch(setApiError());
		saveServerLogs(e.stack, 'error', PATHS.EXPENSE_HISTORY);
    }
}

export const deleteExpenseItem = (expenseId, itemId) => async dispatch => {
    dispatch(setApiLoading(true));
    try{
        const resp = await axiosApiCaller.delete(PATHS.EXPENSE_ITEM_API, {
            params: {
                id: expenseId,
                itemId,
            }
        });
        const { data } = resp || {};
        if (data && data.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
            dispatch(saveExpenseDetails(data));
            dispatch(fetchExpenseHistory({expId: expenseId}));
            dispatch(setApiSuccess({
                ...defaultSuccessModalData,
                desc: API_MESSAGE.DELETE_EXPNS,
                btnTxt: 'OK'
            }));
        } else {
            const { message = ''} = data || {};
            dispatch(setApiError({
                ...defaultErrorModalData,
                desc: message,
            }));
        }
    } catch(err) {
        dispatch(setApiError());
		saveServerLogs(e.stack, 'error', PATHS.EXPENSE_ITEM_API);
    }
}

export const deleteExpense = (expenseId, history) => async dispatch => {
    const deleteExpenseAPI = `${PATHS.EXPENSE_API}/${expenseId}`;
    dispatch(setApiLoading(true));
    try{
        const resp = await axiosApiCaller.delete(deleteExpenseAPI);
        const { data } = resp || {};
        if (data && data.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
            history.push(PATHS.TRAVEL_EXPENSE);
        } else {
            dispatch(setApiError());
        }
    } catch(err) {
        dispatch(setApiError());
		saveServerLogs(e.stack, 'error', PATHS.EXPENSE_API);
    }
}

export const saveExpense = ({reqData={}, history, redirectData}) => async (dispatch) => {
    dispatch(setApiLoading(true));
    try {
        const { userName, status } = redirectData || {};
        const resp = await axiosApiCaller.put(PATHS.EXPENSE_API, reqData);
        const { data } = resp || {};
        const { id: reqId } = reqData;
        if (data && data.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
            const { id } = data;
            if (redirectData) {
                setToastData({userName, status});
                history.push(PATHS.TRAVEL_EXPENSE);
            }else if (reqId) {
                dispatch(saveExpenseDetails(data));
                dispatch(fetchExpenseHistory({expId: id}));
                dispatch(setApiSuccess({
                    ...defaultSuccessModalData,
                    desc: API_MESSAGE.SAVE_EXPNS,
                    btnTxt: 'OK',
                }))
            }else if (history && id){
                history.push(`${PATHS.EXPENSE_DETAILS}?id=${id}`);
            } else if (id) {
                window.open(`${PATHS.EXPENSE_DETAILS}?id=${id}`);
            }         
        } else {
            if (reqId) {
                const { message = ''} = data || {};
                dispatch(setApiError({
                    ...defaultErrorModalData,
                    desc: message,
                }));
            } else {
                dispatch(setApiError(technicalIssueData));
            }
        }
    } catch (err) {
        dispatch(setApiError(technicalIssueData));
		saveServerLogs(e.stack, 'error', PATHS.EXPENSE_API);
    }
}

export const approveRejectExpense = ({reqData, expenseId, mobileModal, redirectData, authCode}) => async (dispatch) => {
    dispatch(setApiLoading(true));
    let isError = false;
    const params = getCommonParams({expId: expenseId, authCode})
    try {
        const { userName, status, history} = redirectData || {};
        setToastData({userName, status});
        let resp = {};
        if (authCode) {
            resp = await axiosApiCaller.post(PATHS.APPROVE_REJECT_AUTH, reqData, {
                params
            });
        } else {
            resp = await axiosApiCaller.put(PATHS.APPROVE_REJECT_EXPNS, reqData, {
                params
            });
        }
        const { data } = resp || {};
        if (data && data.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
            dispatch(saveExpenseDetails(data));
            if (mobileModal) {
                dispatch(setApiSuccess(mobileModal));
                //dispatch(fetchExpenseHistory({expId: data.id, authCode}));
            } else {  
                history.push(PATHS.TRAVEL_EXPENSE);
            }
        } else {
            dispatch(setApiError());
            isError = true;
        }
    } catch (err) {
        isError = true;
        dispatch(setApiError());
		saveServerLogs(e.stack, 'error', PATHS.APPROVE_REJECT_EXPNS);
    } finally {
        isError &&  removeToastData();    
    }
}

export const clearExpenseData = () => ({
    type: EXPENSE_DETAILS_CONST.CLEAR_EXPNS
})
